export class LevelMinData{
  subTopicCount=0
  topicCount=0
  syllabusCode=""
}
